import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'SIGNED_REQUEST_GET',
  GET_SUCCESS: 'SIGNED_REQUEST_GET_SUCCESS',
  GET_FAILURE: 'SIGNED_REQUEST_GET_FAILURE',
};

const dummyActivityRef = 'test_tech';

export const get = actions.get(
  () => `${BASE_URL}/curriculum/learnosity-activity-ref/${dummyActivityRef}/signed-key`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
